import { DependencyInjectionContainer } from "./dependency-injection-container";
import { OurNodeset } from "../poc/our-nodeset";

const initialStructureNodesetKey = "initialStructureNodeset";

export const getInitialStructureNodeset = () => {
  return DependencyInjectionContainer.getInstance().resolve<OurNodeset>(
    initialStructureNodesetKey,
  );
};

export const registerInitialStructureNodeset = () => {
  DependencyInjectionContainer.getInstance().register(
    initialStructureNodesetKey,
    OurNodeset,
  );
};
